import Vue from 'vue'
import store from '../store'

/*
* 检查规则
* 1，a 在 数组中
* 2，a,b 都在数组中
* 3、a,b 有至少一个在数组中
* --> 4、a,b,x,... 至少要有n个在数组中
* --> 5，在数组中含有指定前缀的
* --> 6、在数组中含有指定后缀的
*
* 指令名称
* 1, v-permission
* 2, v-role
*
* binding.modifiers 参数含义
* 默认：至少含有一个
* has  // 至少含有一个
* both // 全部包含
* hide // 条件不满足时，有其，则存在DOM中，逻辑隐藏；否则从DOM树中移除，永久不再显示
* --> prefix // 含有指定前缀的
* --> suffix // 含有指定后缀的
*
* */

// 指令注册

Vue.directive('permission', {
  inserted: function (el, binding) {
    let array = store.getters.permissions
    inserted(el, binding, array)
  },
  update: function (el, binding) {
    let array = store.getters.permissions
    update(el, binding, array)
  }
})

Vue.directive('role', {
  inserted: function (el, binding) {
    let array = store.getters.roles
    inserted(el, binding, array)
  },
  update: function (el, binding) {
    let array = store.getters.roles
    update(el, binding, array)
  }
})

// 内部函数

function inserted (el, binding, array) {
  if (check(binding, array) === false) {
    if (binding.modifiers['hide']) {
      el.style.display = 'none'
    } else {
      el.parentNode.removeChild(el)
    }
  }
}

function update (el, binding, array) {
  if (binding.modifiers['hide']) {
    if (check(binding, array) === false) {
      el.style.display = 'none'
    } else {
      el.style.display = ''
    }
  }
}

function check (binding, array) {
  let data = binding.value
  let both = binding.modifiers['both']
  return startCheck(data, both, array)
}

// 过滤器补充，解决el-组件部分子组件对v-permission、v-role无效的问题

Vue.filter('permission', function (value, both) {
  return startCheck(value, both, store.getters.permissions)
})

Vue.filter('role', function (value, both) {
  return startCheck(value, both, store.getters.roles)
})

// 检查工具

function startCheck (data, both, array) {
  if (isArray(data)) {
    let result = both
    for (let i = 0; i < data.length; i++) {
      let item = data[i]
      result = array.includes(item)
      if (result === !both) {
        break
      }
    }
    return result
  } else if (isString(data)) {
    return array.includes(data)
  }
}

function isArray (value) {
  if (typeof Array.isArray === 'function') {
    return Array.isArray(value)
  } else {
    return Object.prototype.toString.call(value) === '[object Array]'
  }
}

function isString (obj) {
  return typeof obj === 'string'
}
